import { render, staticRenderFns } from "./ViewRevenue.vue?vue&type=template&id=2aef1c48"
import script from "./ViewRevenue.vue?vue&type=script&lang=js"
export * from "./ViewRevenue.vue?vue&type=script&lang=js"
import style0 from "./ViewRevenue.vue?vue&type=style&index=0&id=2aef1c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports